// @ts-nocheck
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import _ from "lodash";
import moment from "moment-timezone";
import styled, { css } from "styled-components";

import EditEventModal from "components/modals/edit-event-modal";
import { Breadcrumb, Button, Container, Frame, RowWrapper, TExtra } from "components/ui-kit/styled-templates";

import { EVENT_TYPES_OPTIONS } from "constants/config";

import EventsApi from "api/events-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";

import { EModals } from "types/enums";

const EventsPage = () => {
    const { t } = useTranslation();

    useBodyBackground(`white`);

    const myUniversityId = useStorageListener(`myUniversityId`);
    const events = useStorageListener((state) => _.values(state?.events)?.filter?.((i) => i?.universityId === myUniversityId) ?? []);

    const handlers = {
        createEvent: () => {
            ModalsService.showModal(EModals.CreateEvent, { mode: `create` , data: {details: {isAlwaysAvailable: true}}});
        },
        editEvent: (id: string) => () => {
            ModalsService.showModal(EModals.CreateEvent, { mode: `edit`, data: _.find(events, { id }) });
        },
        duplicateEvent: (id: string) => () => {
            const eventToDuplicate = _.find(events, { id });
            if (!eventToDuplicate) return;

            const duplicatedDetails = {
                ...eventToDuplicate.details,
                name: `${eventToDuplicate.details?.name || 'Событие'} (Копия)`
            };

            ModalsService.showModal(EModals.CreateEvent, {
                mode: `create`,
                data: { details: duplicatedDetails }
            });
        },
        deleteDormitory: (id: string) => async () => {
            ModalsService.showModality({
                title: `Удаление события`,
                description: `Вы уверены, что хотите удалить событие "${_.find(events, { id })?.details?.name ?? `без названия`}"?`,
                cancelButton: {
                    children: `Отмена`,
                    background: `gray`,
                    onClick: () => {},
                },
                confirmButton: {
                    children: `Удалить`,
                    background: `red`,
                    // onClick: async () => await EventsApi.deleteEvent(id),
                    onClick: () => {
                        EventsApi.deleteEvent(id);
                    },
                },
            });
        },
    };

    // @ts-ignore
    useEffect(EventsApi.getMyUniversityEvents, []);

    return (
        <>
            <EditEventModal />

            <Container extra={`align-items: flex-start;`}>
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("3fwyu82o8oq")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
                <RowWrapper extra={`h1 { margin: 0; };`}>
                    <h1>{t("2ji05x5yk12")}</h1>
                    <Button variant="outlined" onClick={handlers.createEvent}>
                        {t("4oqch26sxoh")}
                    </Button>
                </RowWrapper>
                <RowWrapper extra={`margin-top: 56px; flex-wrap: wrap; gap: 40px;`}>
                    {_.values(events)?.map?.(({ details: item = {}, id, onModeration }: any, index: any) => (
                        <EventTab.Component key={index} {...{ item, id, handlers, onModeration }} />
                    ))}
                </RowWrapper>
                {!_.values(events).length && <NotFoundWrapper>{t("nzzp8ox7pp")}</NotFoundWrapper>}
            </Container>
        </>
    );
};

enum EEventTabStatus {
    Accept = `accept`,
    Verification = `verification`,
    Reject = `reject`,
    Process = `process`,
    None = `none`,
}

export const EventTab = {
    Component: (props: { onModeration: boolean; moderationComment: string; item: any; id: string; handlers: { editEvent: Function; deleteDormitory: Function; duplicateEvent?: Function } }) => {
        const { t } = useTranslation();

        const { item, id, handlers, onModeration, moderationComment } = props;

        const status = onModeration ? EEventTabStatus.Verification : EEventTabStatus.Accept;

        return (
            <EventTab.Wrapper>
                <EventTab.WarningSign status={status} />
                <EventTab.Name empty={_.isEmpty(item?.name)}>{item?.name ?? `Без имени`}</EventTab.Name>

                {((onModeration == true) && (moderationComment != undefined)) ?
                    <>
                        <div style={{color: 'red', opacity: 0.5}} className={'flex flex-row items-center'} >
                            <span className={'mr-1 '}  >
                                <svg height={22} style={{display: 'inline-block', marginTop: '-4px'}} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                                     stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                                </svg>
                            </span>
                            {`Комментарий модерации: ${moderationComment}`}
                        </div>
                    </>
                    : null
                }


                <EventTab.Type>{EVENT_TYPES_OPTIONS?.find?.((i) => i?.value === item?.type)?.label}</EventTab.Type>
                <EventTab.DetailsWrapper>
                    <div>
                        <div>{t("hr32czr2iro")}</div>
                        <strong>{item?.price} ₽</strong>
                    </div>
                    <div>
                        <div>{t("v9zgoy3uzko")}</div>
                        <strong>
                            {moment(item?.dates?.from).format(`DD.MM.YYYY`)} - {moment(item?.dates?.to).format(`DD.MM.YYYY`)}
                        </strong>
                    </div>
                </EventTab.DetailsWrapper>
                <Link to={`/events/${id}`}>
                    <EventTab.Link color="blue">{t("oumubqaxaxl")}</EventTab.Link>
                </Link>
                <EventTab.Link color="blue" onClick={handlers.editEvent(id)}>
                    {t("1tcslwpzln8")}
                </EventTab.Link>
                {handlers.duplicateEvent && (
                    <EventTab.Link color="blue" onClick={handlers.duplicateEvent(id)}>
                        Дублировать
                    </EventTab.Link>
                )}
                <EventTab.Link color="red" onClick={handlers.deleteDormitory(id)}>
                    {t("wsu44mvxyz")}
                </EventTab.Link>
            </EventTab.Wrapper>
        );
    },
    Type: styled(Frame)`
        color: ${({ theme }) => theme.blue};
        font-size: 13px;
        line-height: 17px;
    `,
    WarningSign: styled(Frame)<{ status?: EEventTabStatus }>`
        width: 24px;
        height: 24px;
        background: url("${({ status = EEventTabStatus.None }) => require(`assets/icons/dormitory-status-${status}.svg`)}") no-repeat center center /
            contain;

        position: absolute;
        top: 10px;
        right: 10px;
    `,
    Wrapper: styled(Frame)<{ status?: EEventTabStatus }>`
        width: calc(50% - 20px);
        padding: 24px 20px;
        box-sizing: border-box;
        border: 1px solid ${({ theme }) => theme.halfblue};
        border-radius: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px 0;
        position: relative;

        > * {
            margin: 0;
        }

        @media (max-width: 991px) {
            width: inherit;
        }
    `,
    Name: styled.h3<{ empty: boolean; extra?: TExtra }>`
        color: ${({ theme, empty }) => (empty ? theme.text.light : theme.text.primary)};

        ${({ extra }) => extra}
    `,
    Link: styled(Frame)<{ color: `red` | `blue`; direction?: `right` | `left` }>`
        color: ${({ theme, color }) => theme[color]};
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        display: flex;
        align-items: center;
        flex-direction: row;
        cursor: pointer;

        ${({ direction = `right` }) => (direction === `right` ? `&:after` : `&:before`)} {
            content: "";
            width: 12px;
            height: 12px;
            background: url("${({ color }) => require(`assets/icons/arrow-right-${color}.svg`)}") no-repeat center center / contain;
            margin-left: 8px;
            transition: 0.2s;

            ${({ direction = `right` }) =>
                direction === `left` &&
                css`
                    transform: rotate(180deg);
                    margin-left: unset;
                    margin-right: 8px;
                `}
        }

        &:hover {
            ${({ direction = `right` }) => (direction === `right` ? `&:after` : `&:before`)} {
                transform: translateX(${({ direction = `right` }) => (direction === `right` ? 3 : -3)}px)
                    ${({ direction = `right` }) => (direction === `left` ? `rotate(180deg)` : ``)};
            }
        }
    `,
    DetailsWrapper: styled(RowWrapper)`
        > * {
            margin-bottom: 8px;
            width: 100%;

            p {
                margin-bottom: 8px;
            }
        }

        @media (max-width: 991px) {
            flex-wrap: wrap;
            > * {
                width: 50%;
            }
        } ;
    `,
};

export const NotFoundWrapper = styled(Frame)`
    width: inherit;
    color: ${({ theme }) => theme.grey};
    padding: 40px 0;
`;

export default EventsPage;
